module.exports = __webpack_public_path__ + "static/media/BlogImg1.099e6b47.png";